import { Component, OnInit, Inject, PLATFORM_ID, Input } from '@angular/core';
import { IProductCategory } from '../../_models/iproduct-category';
import { ProductCategoryService } from '../../_services/product-category.service';
import { AppConstants } from '../../_constants/constants';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-side-nav-categories',
    templateUrl: './side-nav-categories.component.html',
    styleUrls: ['./side-nav-categories.component.css'],
    standalone: false
})
export class SideNavCategoriesComponent implements OnInit {

    @Input() activeSlug: string = '';

    categories: IProductCategory[] = [];
    currentLanguage: string | null = null;

    constructor(
        private pcService: ProductCategoryService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) { }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.currentLanguage = localStorage.getItem(AppConstants.CURRENT_LANG_STORE_KEY);
        }
        this.pcService.get_product_categories().subscribe((categories) => this.categories = categories);
    }

}
